import * as React from "react";

import placeholderImg from "assets/svg/settings/cards.svg";
import { NoMobileScreen } from "components/mobile/NoMobileScreen";

export const NoMobile: React.FC = () => (
  <NoMobileScreen
    icon={placeholderImg}
    description={
      <>
        <strong>Email templates</strong> are not available on mobile devices. Please switch to a desktop browser for a
        better experience.
      </>
    }
  />
);
